export const socialMediaAccordion = {
  trigger: {
    title: "Social Media",
    description: "Mass delete your content from major social media platforms.",
    items: [
      {
        isIcon: false,
        iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
        text: "Limited",
      },
      {
        isIcon: true,
        iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
        text: "",
      },
      {
        isIcon: true,
        iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
        text: "",
      },
    ],
  },
  content: [
    {
      title: "Twitter",
      items: [
        {
          isIcon: false,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "Limited",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Reddit",
      items: [
        {
          isIcon: false,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "Limited",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Discord",
      items: [
        {
          isIcon: false,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "Up to past 30 days",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Facebook",
      items: [
        {
          isIcon: false,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "Up to past 30 days",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Steam",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Imgur",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Deviantart",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Pinterest",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Tumblr",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Telegram",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "MyAnimeList",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Disqus",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Gyazo",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Bumble",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Bluesky",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Mastodon",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
  ],
};

export const workAndProdAccordion = {
  trigger: {
    title: "Work and productivity",
    description: "Mass delete your content from major work and productivity platforms.",
    items: [
      {
        isIcon: true,
        iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
        text: "",
      },
      {
        isIcon: true,
        iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
        text: "",
      },
      {
        isIcon: true,
        iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
        text: "",
      },
    ],
  },
  content: [
    {
      title: "LinkedIn",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Slack",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Skype",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "StackExchange",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Email",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Wordpress",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Quora",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Github",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Medium",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Flickr",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
    {
      title: "Yelp",
      items: [
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-white-100",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[system-uicons--cross] h-[2rem] w-[2rem] text-blue-400",
          text: "",
        },
        {
          isIcon: true,
          iconifyClassName: "icon-[ic--sharp-check] h-[2rem] w-[2rem] text-purple-100",
          text: "",
        },
      ],
    },
  ],
};

export const additionalFeatures = [
  {
    name: "Browser scan - automatically find and link your account to Redact",
    free: true,
    premium: true,
    ultimate: true,
  },
  {
    name: "Desktop and mobile version included",
    free: true,
    premium: true,
    ultimate: true,
  },
  {
    name: "Priority Support",
    free: "Limited",
    premium: true,
    ultimate: true,
  },
  {
    name: "Built in archiver to save deleted content to your device",
    free: "Limited",
    premium: "Limited",
    ultimate: true,
  },
  {
    name: "Schedule and automate regular deletions",
    free: false,
    premium: true,
    ultimate: true,
  },
  {
    name: "Multi-account support",
    free: false,
    premium: "2 Accounts per service",
    ultimate: "5 Accounts per service",
  },
  {
    name: "File Import",
    free: false,
    premium: true,
    ultimate: true,
  },
  {
    name: "Advanced options for all services",
    free: false,
    premium: "Limited",
    ultimate: true,
  },
];

export const faqList = [
  {
    title: "What payment options are supported?",
    description:
      "On desktop we support Paypal & Stripe. On mobile all purchases are handled by the respective app stores.",
    url: null,
  },
  {
    title: "Why should I redact my social media content?",
    description:
      "Data brokers, scammers and large corporations are processing and selling your data on a scale that was not possible a few years ago. No one who is looking through your old posts from a 5 years ago is up to anything good.",
    url: null,
  },
  {
    title: "Does redact collect any personal information?",
    description:
      "Redact does not collect, store or monitor any personal data outside of email address used for account creation & billing details via our payment processors. We are currently looking to support privacy friendly payment methods.",
    url: null,
  },
  {
    title: "What services do you support?",
    description: "You can read a full list of services and features here!",
    url: "/services",
  },
  {
    title: "Is Redact safe to use?",
    description:
      "Redact is a privacy first company. That means we collect as little of your data as possible, and anonomize data related to your account. We ensure that no one - not even Redact - can view any of your content that you manage in the Redact app.",
    url: null,
  },
];
